import { CarWheelPositionTextLabels, VehicleCategory, VehicleTopologyRecord } from '@navio/nsdk';

const VEHICLE_CATEGORY_VALUES = new Set<string>(Object.values(VehicleCategory));

const isVehicleCategory = (value: unknown): value is VehicleCategory =>
  typeof value === 'string' && VEHICLE_CATEGORY_VALUES.has(value);

const vehicleCategoryFromUnknown = (value: unknown): VehicleCategory | undefined =>
  isVehicleCategory(value) ? value : undefined;

export const vehicleCategoryFromRecord = (record: object): VehicleCategory | undefined =>
  'vehicleCategory' in record ? vehicleCategoryFromUnknown(record.vehicleCategory) : undefined;

const PASSENGER_LIKE_CATEGORIES = new Set<VehicleCategory>([VehicleCategory.PASSENGER, VehicleCategory.LCV]);

export const usesPassengerVehicleIllustration = (category: VehicleCategory) => PASSENGER_LIKE_CATEGORIES.has(category);

export const formatVehicleTopology = (topology: VehicleTopologyRecord) => {
  const positions = topology.positions.map((position) => CarWheelPositionTextLabels[position]).join(', ');
  return `${topology.expectedWheelCount} wheels · ${positions}`;
};
